import type { I18n, MessageDescriptor } from '@lingui/core';
import { z } from 'zod';

/**
 * Texto que vai em props de bloco: literal ou descritor do Lingui (`msg`). Os dois são JSON, então
 * a configuração continua serializável (08 §4.3) e a tradução acontece em quem desenha (U33).
 */
export const textSchema = z.union([z.string().max(200), z.object({ id: z.string().min(1), message: z.string().optional() })]);

/** Descritor como sai do JSON (o `message` pode vir ausente ou `undefined`). */
export interface SerializedText {
  readonly id: string;
  readonly message?: string | undefined;
}

export type PatternText = string | MessageDescriptor | SerializedText;

/** Resolve um `PatternText` no idioma ativo. */
export function resolvePatternText(i18n: I18n, text: PatternText): string {
  if (typeof text === 'string') return text;
  return i18n._(text.message === undefined ? { id: text.id } : (text as MessageDescriptor));
}

/** Lê um campo por caminho com ponto (`owner.name`), como o `_.get` do legado. */
export function readPath(source: unknown, path: string): unknown {
  let node: unknown = source;
  for (const key of path.split('.')) {
    if (typeof node !== 'object' || node === null) return undefined;
    node = (node as Record<string, unknown>)[key];
  }
  return node;
}
